export function getDateVersion(): string {
  const currentDate = new Date();
  return `${currentDate.getMonth() + 1}.${currentDate.getDate()}.${currentDate.getFullYear()}`;
}

export function getVersion(): string {
  return "1.0.8";
}
